import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=b86ce000&scoped=true&"
import script from "./phoneNumber.vue?vue&type=script&lang=js&"
export * from "./phoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86ce000",
  null
  
)

export default component.exports